import Layout from "../Frames/Layout"
import { useNavigate, useParams } from "react-router-dom";
import PostForm from "./PostForm";

export default function Form(){

    const {id} = useParams()

    const navigate = useNavigate()

    const section = (new URL(document.location)).searchParams.get('section');

    const handleEnd = () => navigate('/community/feed')

    return <Layout tab='feed' menu='social' className='social'>
        <div className='social-main'>

            <PostForm 
                id={id} 
                section={section}
                onSubmit={handleEnd}
                onClose={handleEnd}
            />

        </div>
    </Layout>
}
